import type { NavState } from '@/components/organisms/NavOverlay'
import { createContext } from 'react'

type SetNavStateFn = (state: NavState) => void

export const setNavStateContext = createContext<SetNavStateFn>(() => {})
